import React from "react";

import classes from './CustomBackground.module.css';

import { Container } from 'react-bootstrap';
import { backgroundImages } from "../../../shared/utility";

const CustomBackground = (props: any) => {
  const customBackgroundClassess = ["pr-0", "pl-0", classes.customBackground, getBackgroundImage(props.image)];

  return (
    <Container fluid className={customBackgroundClassess.join(" ")}>
      {props.children}
    </Container>
  );
};

const getBackgroundImage = (image: string) => {
  switch (image) {
    case backgroundImages.SPECIES: return classes.species;
    case backgroundImages.DENOMINATION: return classes.denomination;
    case backgroundImages.MY_TESTS: return classes.mytests;
    default: return classes.varieties;
  }
}

export default CustomBackground;
